export default [{
  path: 'home',
  name: '演示',
  props: true,
  component: () => import('@/components/demo/index.vue')
}, {
  path: 'm-accordion',
  name: 'm-accordion',
  component: () => import('@/generated/accordion/demo.vue')
}, {
  path: 'm-action-sheet',
  name: 'm-action-sheet',
  component: () => import('@/generated/action-sheet/demo.vue')
}, {
  path: 'm-activity-indicator',
  name: 'm-activity-indicator',
  component: () => import('@/generated/activity-indicator/demo.vue')
}, {
  path: 'm-badge',
  name: 'm-badge',
  component: () => import('@/generated/badge/demo.vue')
}, {
  path: 'm-button',
  name: 'm-button',
  component: () => import('@/generated/button/demo.vue')
}, {
  path: 'm-calendar',
  name: 'm-calendar',
  component: () => import('@/generated/calendar/demo.vue')
}, {
  path: 'm-card',
  name: 'm-card',
  component: () => import('@/generated/card/demo.vue')
}, {
  path: 'm-carousel',
  name: 'm-carousel',
  component: () => import('@/generated/carousel/demo.vue')
}, {
  path: 'm-chart',
  name: 'm-chart',
  component: () => import('@/generated/chart/demo.vue')
}, {
  path: 'm-checkbox',
  name: 'm-checkbox',
  component: () => import('@/generated/checkbox/demo.vue')
}, {
  path: 'm-date-picker',
  name: 'm-date-picker',
  component: () => import('@/generated/date-picker/demo.vue')
}, {
  path: 'm-date-picker-view',
  name: 'm-date-picker-view',
  component: () => import('@/generated/date-picker-view/demo.vue')
}, {
  path: 'm-drawer',
  name: 'm-drawer',
  component: () => import('@/generated/drawer/demo.vue')
}, {
  path: 'm-flex',
  name: 'm-flex',
  component: () => import('@/generated/flex/demo.vue')
}, {
  path: 'm-grid',
  name: 'm-grid',
  component: () => import('@/generated/grid/demo.vue')
}, {
  path: 'm-icon',
  name: 'm-icon',
  component: () => import('@/generated/icon/demo.vue')
}, {
  path: 'm-image-picker',
  name: 'm-image-picker',
  component: () => import('@/generated/image-picker/demo.vue')
}, {
  path: 'm-input',
  name: 'm-input',
  component: () => import('@/generated/input/demo.vue')
}, {
  path: 'm-list',
  name: 'm-list',
  component: () => import('@/generated/list/demo.vue')
}, {
  path: 'm-menu',
  name: 'm-menu',
  component: () => import('@/generated/menu/demo.vue')
}, {
  path: 'm-modal',
  name: 'm-modal',
  component: () => import('@/generated/modal/demo.vue')
}, {
  path: 'm-nav-bar',
  name: 'm-nav-bar',
  component: () => import('@/generated/nav-bar/demo.vue')
}, {
  path: 'm-notice-bar',
  name: 'm-notice-bar',
  component: () => import('@/generated/notice-bar/demo.vue')
}, {
  path: 'm-pagination',
  name: 'm-pagination',
  component: () => import('@/generated/pagination/demo.vue')
}, {
  path: 'm-picker',
  name: 'm-picker',
  component: () => import('@/generated/picker/demo.vue')
}, {
  path: 'm-popover',
  name: 'm-popover',
  component: () => import('@/generated/popover/demo.vue')
}, {
  path: 'm-popup',
  name: 'm-popup',
  component: () => import('@/generated/popup/demo.vue')
}, {
  path: 'm-progress',
  name: 'm-progress',
  component: () => import('@/generated/progress/demo.vue')
}, {
  path: 'm-pull-refresh',
  name: 'm-pull-refresh',
  component: () => import('@/generated/pull-refresh/demo.vue')
}, {
  path: 'm-radio',
  name: 'm-radio',
  component: () => import('@/generated/radio/demo.vue')
}, {
  path: 'm-range',
  name: 'm-range',
  component: () => import('@/generated/range/demo.vue')
}, {
  path: 'm-result',
  name: 'm-result',
  component: () => import('@/generated/result/demo.vue')
}, {
  path: 'm-search-bar',
  name: 'm-search-bar',
  component: () => import('@/generated/search-bar/demo.vue')
}, {
  path: 'm-segmented-control',
  name: 'm-segmented-control',
  component: () => import('@/generated/segmented-control/demo.vue')
}, {
  path: 'm-slider',
  name: 'm-slider',
  component: () => import('@/generated/slider/demo.vue')
}, {
  path: 'm-stepper',
  name: 'm-stepper',
  component: () => import('@/generated/stepper/demo.vue')
}, {
  path: 'm-steps',
  name: 'm-steps',
  component: () => import('@/generated/steps/demo.vue')
}, {
  path: 'm-switch',
  name: 'm-switch',
  component: () => import('@/generated/switch/demo.vue')
}, {
  path: 'm-tab-bar',
  name: 'm-tab-bar',
  component: () => import('@/generated/tab-bar/demo.vue')
}, {
  path: 'm-tabs',
  name: 'm-tabs',
  component: () => import('@/generated/tabs/demo.vue')
}, {
  path: 'm-tag',
  name: 'm-tag',
  component: () => import('@/generated/tag/demo.vue')
}, {
  path: 'm-textarea',
  name: 'm-textarea',
  component: () => import('@/generated/textarea/demo.vue')
}, {
  path: 'm-toast',
  name: 'm-toast',
  component: () => import('@/generated/toast/demo.vue')
}, {
  path: 'm-white-space',
  name: 'm-white-space',
  component: () => import('@/generated/white-space/demo.vue')
}, {
  path: 'm-wing-blank',
  name: 'm-wing-blank',
  component: () => import('@/generated/wing-blank/demo.vue')
}];
